// @ is an alias to /src
const bannerImgs = [
  {
    src: banner1
  },
  {
    src: banner1
  }
]

const detailTabs = {
  product: '产品介绍',
  video: '视频教学'
}

const navs = [
  {
    name: '首页',
    id: ''
  },
  {
    name: '产品优势',
    id: 'advantages'
  },
  {
    name: '产品价格',
    id: 'price'
  },
  {
    name: '工程应用',
    id: 'engineeringApplication'
  },
  {
    name: '研发团队',
    id: 'team'
  },
/*   {
    name: '产品下载',
    id: 'price'
  }, */
  // {
  //   name: '公司简介',
  //   id: 'intro'
  // },
  {
    name: '联系我们',
    id: 'contact'
  }
]

// 产品演示
import banner1 from '@/assets/banner1.png'
import showHow1 from '@/assets/show_hows/showHow1.png'
import showHow2 from '@/assets/show_hows/showHow2.png'
import showHow3 from '@/assets/show_hows/showHow3.png'
import showHow4 from '@/assets/show_hows/showHow4.png'
import showHow5 from '@/assets/show_hows/showHow5.png'
const showHowVideos = [
  {
    img: showHow1,
    link: 'https://v.qq.com/x/page/x0911syagnc.html?'
  },
  {
    img: showHow2,
    link: 'https://v.qq.com/x/page/x0911vy1r3y.html?'
  },
  {
    img: showHow3,
    link: 'https://v.qq.com/x/page/q0911892j07.html?'
  },
  {
    img: showHow4,
    link: 'https://v.qq.com/x/page/n0911lv8fec.html?'
  },
  {
    img: showHow5,
    link: 'https://v.qq.com/x/page/m0911pbnefu.html?'
  }
]

// 工程应用
import ea1 from '@/assets/engineering_Application/珠海万菱环球中心.png'
import ea2 from '@/assets/engineering_Application/广东美术馆“三馆合一”项目.png'
import ea3 from '@/assets/engineering_Application/广州知识塔.png'
import ea4 from '@/assets/engineering_Application/深圳华侨城坪山之眼.png'
import ea5 from '@/assets/engineering_Application/昆明保利南亚之窗.png'
import ea6 from '@/assets/engineering_Application/珠海格力新经济创投中心.png'
import ea7 from '@/assets/engineering_Application/深圳湾万科总部大厦.png'
import ea8 from '@/assets/engineering_Application/佛山八方艺术街区.png'
import ea9 from '@/assets/engineering_Application/重庆航空金融总部.png'
import ea10 from '@/assets/engineering_Application/广州恒泰科技创新产业园.png'
import ea11 from '@/assets/engineering_Application/佛山天珺秀台.png'
import ea12 from '@/assets/engineering_Application/广州白云站上盖项目.png'
import ea13 from '@/assets/engineering_Application/华工大国际校区图书馆.png'
import ea14 from '@/assets/engineering_Application/广州华夏学院图书馆.png'
import ea15 from '@/assets/engineering_Application/广州增城金竹酒店项目.png'
import ea16 from '@/assets/engineering_Application/广州1978国际人才港.png'
import ea17 from '@/assets/engineering_Application/深圳大运文化艺术公园.png'
import ea18 from '@/assets/engineering_Application/东北大学佛山研究生院教学综合体.png'
import ea19 from '@/assets/engineering_Application/武汉三镇中心项目.png'
import ea20 from '@/assets/engineering_Application/贵阳恒峰项目.png'
import ea21 from '@/assets/engineering_Application/粤港澳大湾区（广州）科技金融中心.png'
import ea22 from '@/assets/engineering_Application/珠海浙商总部大厦.png'

const engineeringApplicationVideos = [
  {
    img: ea3,
    link: 'https://mp.weixin.qq.com/s/uR_TrfDkY8FUa5FIXKCDLQ',
    title: '中新广州知识塔——330m知识城在建第一高楼',
    desc: '广州中新知识塔'
  },
  {
    img: ea7,
    link: '',
    title: '深圳湾万科总部大厦',
    desc: '深圳湾万科总部大厦'
  },
  {
    img: ea1,
    link: 'https://mp.weixin.qq.com/s/TqLwbi9jgj0haaAVlYYtRQ',
    title: '珠海万菱环球中心——300m拱北摩天新地标',
    desc: '珠海万菱环球中心'
  },
  {
    img: ea19,
    link: '',
    title: '武汉三镇中心项目',
    desc: '武汉三镇中心项目'
  },
  {
    img: ea5,
    link: 'https://mp.weixin.qq.com/s/1iIUuUSx4jumHlr_M_qnMQ',
    title: '保利南亚之窗——昆明地标性建筑',
    desc: '昆明保利南亚之窗'
  },
  {
    img: ea20,
    link: '',
    title: '贵阳恒峰项目',
    desc: '贵阳恒峰项目'
  },
  {
    img: ea12,
    link: '',
    title: '广州白云站上盖项目',
    desc: '广州白云站上盖项目'
  },  
  {
    img: ea2,
    link: 'https://mp.weixin.qq.com/s/WVJs9Gs8q4hhz_QeLiPSPA',
    title: '广东美术馆、广东非物质文化遗产展示中心、广东文学馆“三馆合一”项目——岭南文化新地标',
    desc: '广东美术馆“三馆合一”项目'
  },
  {
    img: ea13,
    link: 'https://mp.weixin.qq.com/s/O9iWfaHJjvJbGAq3Z9n12w',
    title: '华南理工大学国际校区图书馆',
    desc: '华南理工大学国际校区图书馆'
  },
  {
    img: ea6,
    link: 'https://mp.weixin.qq.com/s/VZn-Q8zwvIdR0xMAhObwyg',
    title: '格力新经济创投中心——珠海新地标',
    desc: '珠海格力新经济创投中心'
  },
  {
    img: ea22,
    link: '',
    title: '珠海浙商总部大厦',
    desc: '珠海浙商总部大厦'
  },
  {
    img: ea15,
    link: '',
    title: '广州增城金竹酒店项目',
    desc: '广州增城金竹酒店项目'
  },

  
  {
    img: ea9,
    link: '',
    title: '重庆航空金融总部',
    desc: '重庆航空金融总部'
  },
  {
    img: ea21,
    link: '',
    title: '粤港澳大湾区（广州）科技金融中心',
    desc: '粤港澳大湾区（广州）科技金融中心'
  },
  {
    img: ea10,
    link: '',
    title: '广州恒泰科技创新产业园',
    desc: '广州恒泰科技创新产业园'
  },





  {
    img: ea4,
    link: 'https://mp.weixin.qq.com/s/3_WN-o_WakK1Gx0CFIP94Q',
    title: '深圳华侨城坪山之眼——250m坪山新地标',
    desc: '深圳华侨城坪山之眼'
  },
  {
    img: ea16,
    link: '',
    title: '广州1978国际人才港',
    desc: '广州1978国际人才港'
  },

  // {
  //   img: ea8,
  //   link: '',
  //   title: '佛山八方艺术街区',
  //   desc: '佛山八方艺术街区'
  // },

  {
    img: ea11,
    link: 'https://mp.weixin.qq.com/s/Vqfv6icl_6egU6oNX2azLQ',
    title: '佛山保利天珺秀台——2021新版广东省《高规》项目',
    desc: '佛山天珺秀台'
  },
  {
    img: ea17,
    link: '',
    title: '深圳大运文化艺术公园',
    desc: '深圳大运文化艺术公园'
  },
  {
    img: ea14,
    link: '',
    title: '广州华夏学院图书馆',
    desc: '广州华夏学院图书馆'
  },
  {
    img: ea18,
    link: '',
    title: '东北大学佛山研究生院教学综合体',
    desc: '东北大学佛山研究生院教学综合体'
  },





]

export {
  bannerImgs,
  detailTabs,
  navs,
  showHowVideos,
  engineeringApplicationVideos
}
